<i *ngIf="svg" [floSvg]="svg"></i>
<h3 class="video-player-error-title" data-test="video-player-error-title">{{ title }}</h3>
<div class="video-player-error-transcluded">
  <ng-content select="p"></ng-content>
</div>
